<template>
  <b-container fluid>
    <b-container>
      <b-row>
        <b-col xl="9" lg="8" md="7" sm="12">
          <b-row>
            <b-col>
              <div class="list">
                <h5>شیوه پرداخت</h5>

                <div class="pay-icon">
                  <b-icon icon="credit-card" class="icon"/>
                </div>
                <div class="pay-method">
                  <h5>پرداخت اینترنتی</h5>
                  <span>آنلاین با تمامی کارت های بانکی</span>
                </div>
              </div>
            </b-col>

            <b-col>
              <b-card class="list">
                <span>توضیحات پرداخت: {{ payDescription }}</span>
              </b-card>
            </b-col>

            <b-col v-if="(sidebarData.address !== null && sidebarData.address !== undefined) && havePhysicalProduct "
                   lg="12" class="mt-3">
              <b-card class="list">
                <h5>مشخصات گیرنده:</h5>

                <p>
                  <b> گیرنده:</b>
                  {{ receiver(sidebarData.address) }}
                </p>

                <p>
                  <b>آدرس:</b>
                  <span v-if="sidebarData.address.default_address == 0">
                    {{ sidebarData.address.province.name }} - {{ sidebarData.address.city.name }} -
                  {{ sidebarData.address.address }} - {{ cellphone(sidebarData.address) }}
                  </span>
                  <span v-else>{{ sidebarData.address.address }}</span>
                </p>

                <p>
                  <b>توضیحات سفارش:</b>
                  {{ sidebarData.description }}
                </p>

              </b-card>
            </b-col>
          </b-row>

          <div class="list mt-4 ">
            <h5 class="mb-5">خلاصه سفارش</h5>

            <b-row class="text-center">
              <b-col lg="3" md="3" sm="12">
                <h5>تعداد</h5>
                <span>{{ count }} </span>
              </b-col>

              <b-col lg="3" md="3" sm="12">
                <h5>نوع ارسال</h5>
                <span>عادی</span>
              </b-col>

              <b-col lg="6" md="6" sm="12">
                <h5>مبلغ </h5>
                <span>{{ formatNumber(sidebarData.paying_amount) }} <small>تومان</small></span>
              </b-col>
            </b-row>

            <b-row class="mt-5">
              <shopping-card-item-column
                  v-for="item in items"
                  :item_product="item.product"
                  :item="item"
                  :key="item.id"
              />
            </b-row>
          </div>

          <div class="my-3">

            <b-button @click="backPage()" variant="outline-dark">بازگشت به صفحه قبل
              <b-icon icon="chevron-left"/>

            </b-button>

          </div>
        </b-col>

        <b-col class="side-bar" xl="3" lg="4" md="5" sm="12">
          <shopping-card-sidebar
              :items="items"
              :sidebarData="sidebarData"
              :delivery-boundary="deliveryBoundary"
              :delivery-price="deliveryPrice"
              :submit="onSubmit"
              :caption="sideBarContinueText"
          />
          <div class="text-center"><span class="attention ">حداقل خرید برای ارسال رایگان </span>
            <span class="attention">{{ formatNumber(deliveryBoundary) }}</span></div>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>


<script>
import {mapGetters} from "vuex";
import router from '@/router';
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import ShoppingCardItemColumn from "../ShoppingCards/ShoppingCard1/ItemColumn.vue";
import ShoppingCardSidebar from "../ShoppingCards/ShoppingCard1/Sidebar";

export default {
  name: "Payment1",
  components: {ShoppingCardSidebar, ShoppingCardItemColumn},
  props: {
    sideBarContinueText: {
      default: "ادامه فرایند خرید"
    }
  },
  data() {
    return {
      discount_code: "",
    };
  },
  methods: {
    formatNumber,
    onSubmit() {
      this.$store.dispatch("Transaction/createTransaction", this.sidebarData.id)
    },
    onCheck() {
      return false;
    },
    backPage() {
      // if all of the products was digital we stright to the payment page


      if (this.havePhysicalProduct) {
        router.push({name: "Delivery"});
      } else {
        router.push({name: "ShoppingCart"});
      }
    },
    receiver(data) {
      if (data.default_address == 0) {
        if (data.receiver == undefined) {
          return `${data.name} ${data.last_name}`;
        }
        const profile = this.$store.getters["User/getProfile"];
        return `${profile.name} ${profile.last_name}`;
      } else {
        return '-'
      }
    },
    cellphone(data) {
      return data.cellphone === null
          ? data.receiver.cellphone
          : data.cellphone;
    },
  },
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getUserOrderUnpaidItems",
      sidebarData: "ShoppingCart/getSidebarBasketData",
      Addresses: "Address/getAddresses",
      url: "Transaction/getUrl",
      payDescription: "ShoppingCart/getPayDescript",
      deliveryBoundary: "ShoppingCart/getDeliveryBoundary",
      deliveryPrice: "ShoppingCart/getDeliveryPrice",
    }),
    count() {
      var s = 0;
      this.items.forEach((element, key) => {
        s += element.quantity;
      });
      return s;
    },
    havePhysicalProduct() {
      let havePysicalProducts = false;
      this.items.forEach(item => {
        if (item.product.is_digital == 0) {
          havePysicalProducts = true;
        }
      });
      return havePysicalProducts
    }
  },
  mounted() {
    this.$store.dispatch("ShoppingCart/userOrderUnpaid");
  },
};
</script>

<style scoped>
.list {
  background: white;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 2px 4px 10px #eeeeee;
}

.discount input {
  max-width: 200px;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  display: inline-block;
}

.discount button {
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.pay-icon {
  display: inline-block;
  width: 50px;
}

.icon {
  font-size: 25pt;
  color: cyan;
}

.pay-method {
  display: inline-block;
}
</style>